export default __webpack_public_path__ + "static/media/message-bg.0d02f88c.svg";